import { render } from "./Catalog_EditDialog.vue?vue&type=template&id=2aa001b8&scoped=true&ts=true"
import script from "./Catalog_EditDialog.vue?vue&type=script&lang=ts"
export * from "./Catalog_EditDialog.vue?vue&type=script&lang=ts"

import "./Catalog_EditDialog.vue?vue&type=style&index=0&id=2aa001b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa001b8"]])

export default __exports__